/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import './style.scss'


const InfinityScroll = ({
    dataList, callGetData, currentPage, setDataListToDisplay, children,
    pending = false, dataListToDisplay, scrollPosition, setScrollPosition }) => {

    const [isScrolling, setIsScrolling] = React.useState()
    // const [scrollPosition, setScrollPosition] = React.useState()
    const [mainDataList, setMainDataList] = React.useState([]);



    React.useEffect(() => {

        if (dataList.length > 0) {
            setDataListToDisplay([...dataListToDisplay, ...dataList])
        }

        if (mainDataList.length > 0 && dataList) {

        }
        else {
            initializeMainList()
        }

    }, [dataList])

    React.useEffect(() => {


        if (scrollPosition !== undefined) {
            if (document.getElementById("gsfTable")) {
                const tableHeight = document.getElementById("gsfTable").offsetHeight
                const contextHeight = document.getElementById("gsTableContainer").offsetHeight
                const diff = tableHeight - contextHeight
                if (diff === scrollPosition + 1 || diff === scrollPosition || diff + 10 === scrollPosition) {

                    callGetData({ pageNumber: currentPage + 1 })
                }
            }

        }


    }, [scrollPosition])

    const initializeMainList = () => {
        if (mainDataList.length === 0 && dataList?.length > 0) {
            document.getElementById("gsTableContainer").addEventListener("scroll", scrolling)
            let tempList = []
            let tempModel = {}
            tempList.push(tempModel);
            setMainDataList([...tempList])
        }

    }



    const scrolling = (e) => {


        window.clearTimeout(isScrolling);
        const _isScrolling = setTimeout(function () {
            setScrollPosition(Math.round(document.getElementById("gsTableContainer").scrollTop))

        }, 1000);
        setIsScrolling(_isScrolling)

    }


    return (
        <div className='main-infinity-scroll-context'>
            <div className='table-table-container'>
                <div
                    id="gsTableContainer"
                >{children}</div>

            </div>

            {pending && <div className='table-loading '>
                {/* <div className="spinner-border" role="status" aria-hidden="true"></div> */}
            </div>}


        </div>

    )
}

export default InfinityScroll


function makeId() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

    for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

